import React from 'react';
import ReactDOM from 'react-dom';
import CopyMagicContainer from './CopyMagicContainer';
import { CopyMagicPropsInterface } from './CopyMagic.types';

export default abstract class CopyMagicMounter {
  static instances = new Map();

  static registerInstance(id: string, ref: object) {
    this.instances.set(id, ref);
  }

  static deregisterInstance(id: string) {
    if (this.instances.has(id)) {
      this.instances.delete(id);
    }
  }

  // inherited class of abstract class
  private Klass = this.constructor as typeof CopyMagicMounter;

  // @ts-ignore, define props in inherited class
  protected props: CopyMagicPropsInterface;

  // @ts-ignore, define domId in inherited class
  protected domId: string;

  get mountElement(): HTMLElement | null {
    return document.getElementById(this.domId);
  }

  mount() {
    if (!this.mountElement) return;
    ReactDOM.render(<CopyMagicContainer {...this.props} />, this.mountElement);
    this.Klass.registerInstance(this.domId, this);
  }

  unmount() {
    if (!this.mountElement) return;
    ReactDOM.unmountComponentAtNode(this.mountElement);
    this.Klass.deregisterInstance(this.domId);
  }
}
